module.exports = __webpack_public_path__ + "img/INF3105-Pile.c053b0c8.png";